import { render, staticRenderFns } from "./VaFileUploadGalleryItem.vue?vue&type=template&id=4e705ccc&"
import script from "./VaFileUploadGalleryItem.vue?vue&type=script&lang=js&"
export * from "./VaFileUploadGalleryItem.vue?vue&type=script&lang=js&"
import style0 from "./VaFileUploadGalleryItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports